
import _ from 'lodash';

export const findValuesByKey = (values, findKey) => {
	let output = [];

  const recursion = (values, findKey) => {
    _.forIn(values, function(value, key) {
      if (key === findKey) {
        output.push(value[0]);
      }
      else if (Array.isArray(value) || typeof value === 'object') {
        recursion(value, findKey);
      }
    });
  };

  recursion(values, findKey);

  return output;
};
